export const anonymizeLawsuitNumber = (lawsuitNumber: string): string => {
  if (lawsuitNumber === '') return lawsuitNumber
  return `XXXXXXX-XX.${lawsuitNumber.slice(11)}`
}
